import React from "react"
import AddSlide from "./AddSlide"
import { OFFER_BANNER_CONFIG } from "constants/bannerModuleConfig"

const OfferAddSlide = ({ mode }) => (
  <AddSlide mode={mode} moduleConfig={OFFER_BANNER_CONFIG} />
)

export default OfferAddSlide
